import React from 'react'
import { Row, IconButton } from '@fs/zion-ui'
import { ContentDownload } from '@fs/zion-icon/dist/cjs/icons'
import { useTranslation } from 'react-i18next'
import { byteSizeToHumanReadable } from '../../../util/StringUtil'

const UserGedcomFileColumn = ({ file, wrapLine, downloadGedcom }) => {
  const { t } = useTranslation()
  return (
    <span css={wrapLine}>
      <Row>{file.title}</Row>
      <Row>
        {file.fileName}
        <IconButton
          title={t('gedcom.downloadFile', 'Download Gedcom')}
          onClick={() => downloadGedcom(file.fileName)}
          Icon={ContentDownload}
        />
      </Row>
      <Row>{byteSizeToHumanReadable(file.fileSize, true)}</Row>
    </span>
  )
}

export default UserGedcomFileColumn
